import { OpenFileHandle, SaveFileHandle } from './measure_shared/CommonTypes';
import { saveBlob } from './tools_web';

export class WebOpenHandle implements OpenFileHandle {
  public file: File;

  constructor(file: File) {
    this.file = file;
  }

  public open = () => {
    return Promise.resolve(this.file);
  };
}


export class WebSaveHandle implements SaveFileHandle {
  suggestedName: string;

  constructor(suggestedName: string) {
    this.suggestedName = suggestedName;
  }

  public save = async (blob: Blob) => {
    await saveBlob(blob, this.suggestedName);
  };
}